import { Http, Response, URLSearchParams } from '@angular/http';
import { NgModule, Injectable, Inject, OnInit } from '@angular/core';

import { DealershipOverview, NewDealership, Report, UpdateDealership,
  ColourScheme, BrandedStyleDetails, BrandedStyle, DealerGroupV, JobsiteV, JobsiteOverviewModel, NewDealerGroup } from '../models/dealership.model';
import { Tuple } from '../models/tuple.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable()
export class DealershipService {
    private readonly GetAllDealershipsApiAddress = 'api/admin/GetAllDealershipsForUser';
    private readonly GetAllDealerGroupsApiAddress = 'api/admin/GetAllDealerGroupsForUser';
    private readonly GetAllJobsitesApiAddress = 'api/admin/GetAllJobsitesForUser';
    private readonly AddNewDealershipApiAddress = 'api/admin/AddNewDealership';
    private readonly GetAllReportsApiAddress = 'api/admin/GetAllReportTypes';
    private readonly GetAllQuoteReportStylesApiAddress = 'api/admin/GetAllQuoteReportStyles';
    private readonly GetDealershipDetailsApiAddress = 'api/admin/GetDealershipDetails';
    private readonly UpdateDealershipApiAddress = 'api/admin/UpdateDealership';
    private readonly GetAllColourSchemesApiAddress = 'api/admin/GetAllColourSchemes';
    private readonly AddNewBrandedStyleApiAddress = 'api/admin/AddNewBrandedStyle';
    private readonly GetBrandedStyleDetailsApiAddress = 'api/admin/GetBrandedStyleDetails';
    private readonly UpdateBrandedStyleApiAddress = 'api/admin/UpdateBrandedStyle';
    private readonly GetPossibleBrandedStylesForNewUserApiAddress = 'api/admin/GetPossibleBrandedStylesForNewUser';
    private readonly GetAllRopeShovelReportsApiAddress = 'api/admin/GetAllRopeShovelReportTypes';
    private readonly GetAllWearSurfaceReportsApiAddress = 'api/admin/GetAllWearSurfaceReportTypes';
    private readonly GetAllWsreSurfaceReportsApiAddress = 'api/admin/GetAllWsreSurfaceReportTypes';

    
    private readonly GetAllConditionReportsByDGIdApiAddress = 'api/admin/GetFilteredAllReportTypes';
    private readonly AddNewDealerGroupApiAddress = 'api/admin/AddNewDealerGroup';
    private readonly GetDealerGroupDetailsApiAddres = 'api/admin/GetDealerGroupDetails';
    private readonly UpdateDealerGroupApiAddress = 'api/admin/UpdateDealerGroup';




    

    constructor(private _http: HttpClient) { }

    public getPossibleBrandedStylesForNewUser(newUserAccessTypeId: number, newUserDealershipId: number): Observable<BrandedStyle[]> {
      // let params: URLSearchParams = new URLSearchParams();
      // params.set('newUserAccessTypeId', newUserAccessTypeId.toString());
      // params.set('newUserDealershipId', newUserDealershipId.toString());
      // return this._http.get(this.GetPossibleBrandedStylesForNewUserApiAddress, { search: params }).share().map(
      //   (response: Response) => <BrandedStyle[]>response.json()).catch(this.handleError);
      const params = {
        params: new HttpParams().set('newUserAccessTypeId', newUserAccessTypeId.toString())
                                .set('newUserDealershipId', newUserDealershipId.toString())
      };

      return this._http.get<BrandedStyle[]>(this.GetPossibleBrandedStylesForNewUserApiAddress, params).pipe(catchError(this.handleError));
    }

    public getDealershipDetails(dealershipId: number): Observable<NewDealership> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('dealershipId', dealershipId.toString());
        // return this._http.get(this.GetDealershipDetailsApiAddress, { search: params }).share().map(
        //     (response: Response) => <NewDealership>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('dealershipId', dealershipId.toString())
        };
        return this._http.get<NewDealership>(this.GetDealershipDetailsApiAddress, params).pipe(catchError(this.handleError));
    }

    public getBrandedStyleDetails(styleId: number): Observable<BrandedStyleDetails> {
        // let params: URLSearchParams = new URLSearchParams();
        // params.set('styleId', styleId.toString());
        // return this._http.get(this.GetBrandedStyleDetailsApiAddress, { search: params }).share().map(
        //     (response: Response) => <BrandedStyleDetails>response.json()).catch(this.handleError);
        const params = {
          params: new HttpParams().set('styleId', styleId.toString())
        };
        return this._http.get<BrandedStyleDetails>(this.GetBrandedStyleDetailsApiAddress, params).pipe(catchError(this.handleError));
    }

    public getAllColourSchemes(): Observable<ColourScheme[]> {
      return this._http.get<ColourScheme[]>(this.GetAllColourSchemesApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllColourSchemesApiAddress).share().map(
        //     (response: Response) => <ColourScheme[]>response.json()).catch(this.handleError);
    }

    public getAllDealerships(): Observable<DealershipOverview[]> {
      return this._http.get<DealershipOverview[]>(this.GetAllDealershipsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllDealershipsApiAddress).share().map(
        //     (response: Response) => <DealershipOverview[]>response.json()).catch(this.handleError);
    }

    public getAllDealershipsAdmin(dealerRequestModel : any): Observable<DealershipOverview[]> {
      return this._http.post<DealershipOverview[]>(this.GetAllDealershipsApiAddress,dealerRequestModel).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllDealershipsApiAddress).share().map(
        //     (response: Response) => <DealershipOverview[]>response.json()).catch(this.handleError);
    }

    public getAllDealerGroups(): Observable<DealerGroupV[]> {
      return this._http.get<DealerGroupV[]>(this.GetAllDealerGroupsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllDealerGroupsApiAddress).share().map(
        //     (response: Response) => <DealerGroupV[]>response.json()).catch(this.handleError);
    }

    public getAllJobsites(): Observable<JobsiteOverviewModel[]> {
      return this._http.get<JobsiteOverviewModel[]>(this.GetAllJobsitesApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllJobsitesApiAddress).share().map(
        //     (response: Response) => <JobsiteOverviewModel[]>response.json()).catch(this.handleError);
    }
    public updateDealership(newDealership: UpdateDealership): Observable<Tuple> {
      return this._http.post<Tuple>(this.UpdateDealershipApiAddress, newDealership).pipe(catchError(this.handleError));
        // return this._http.post(this.UpdateDealershipApiAddress, newDealership).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
    }

    public updateBrandedStyle(style: BrandedStyleDetails): Observable<Tuple> {
      return this._http.post<Tuple>(this.UpdateBrandedStyleApiAddress, style).pipe(catchError(this.handleError));
        // return this._http.post(this.UpdateBrandedStyleApiAddress, style).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
    }

    public addNewBrandedStyle(style: BrandedStyleDetails): Observable<Tuple> {
      return this._http.post<Tuple>(this.AddNewBrandedStyleApiAddress, style).pipe(catchError(this.handleError));
        // return this._http.post(this.AddNewBrandedStyleApiAddress, style).share().map(
        //     (response: Response) => <Tuple>response.json()).catch(this.handleError);
    }

    public addNewDealership(newDealership: NewDealership): Observable<number> {
      return this._http.post<number>(this.AddNewDealershipApiAddress, newDealership).pipe(catchError(this.handleError));
        // return this._http.post(this.AddNewDealershipApiAddress, newDealership).share().map(
        //     (response: Response) => <number>response.json()).catch(this.handleError);
    }

    public getAllReportTypes(): Observable<Report[]> {
      return this._http.get<Report[]>(this.GetAllReportsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllReportsApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }

    public getAllRopeShovelReportTypes(): Observable<Report[]> {
      return this._http.get<Report[]>(this.GetAllRopeShovelReportsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllReportsApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }

    public getAllGetWearReportTypes(): Observable<Report[]> {
      return this._http.get<Report[]>(this.GetAllWearSurfaceReportsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllReportsApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }

    public getAllWsreReportTypes(): Observable<Report[]> {
      return this._http.get<Report[]>(this.GetAllWsreSurfaceReportsApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllReportsApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }
    
    


    public getAllQuoteReportStyles(): Observable<Report[]> {
      return this._http.get<Report[]>(this.GetAllQuoteReportStylesApiAddress).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllQuoteReportStylesApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }


    public getAllReportTypesByDealerGroupId(dealerGroupId:number): Observable<Report[]> {
      const params = {
        params: new HttpParams().set('dealerGroupId', dealerGroupId.toString())
      };
      return this._http.get<Report[]>(this.GetAllConditionReportsByDGIdApiAddress,params).pipe(catchError(this.handleError));
        // return this._http.get(this.GetAllReportsApiAddress).share().map(
        //     (response: Response) => <Report[]>response.json()).catch(this.handleError);
    }


    ///Dealer Group Codes
    public addNewDealerGroup(newDealerGroup: NewDealerGroup): Observable<number> {
      return this._http.post<number>(this.AddNewDealerGroupApiAddress, newDealerGroup).pipe(catchError(this.handleError));
        // return this._http.post(this.AddNewDealershipApiAddress, newDealership).share().map(
        //     (response: Response) => <number>response.json()).catch(this.handleError);
    }

    public UpdateDealerGroup(newDealerGroup: NewDealerGroup): Observable<number> {
      return this._http.post<number>(this.UpdateDealerGroupApiAddress, newDealerGroup).pipe(catchError(this.handleError));
    }
    public getDealerGroupDetails(dealergroupId: number): Observable<NewDealerGroup> {
      const params = {
        params: new HttpParams().set('dealergroupId', dealergroupId.toString())
      };
      return this._http.get<NewDealerGroup>(this.GetDealerGroupDetailsApiAddres, params).pipe(catchError(this.handleError));
  }

   
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}
